import axios from "../axiosInstance";

class IddStatusService {
  async getIddStatusList() {
    return await axios.get("iddstatus");
  }
}

export default new IddStatusService();
